import React from "react";
import "./style.scss";

const PrimaryButton = ({
  aos,
  aosDelay,
  type,
  style,
  noIcon,
  className,
  isLoading,
  handleClick,
  primaryBtnIcon,
  primaryBtnText,
  primaryExternalLink,
  disabled,
}) => {
  const handleExternalClick = () => {
    window.open(primaryExternalLink, "_blank");
  };
  return (
    <button
      data-aos={aos}
      data-aos-delay={aosDelay}
      style={{ ...style, pointerEvents: isLoading ? "none" : "auto" }}
      type={type || "button"}
      disabled={disabled}
      className={`primary-button ${className ? className : ""}`}
      data-text={primaryBtnText}
      onClick={() => {
        if (handleClick) {
          handleClick?.();
        } else if (primaryExternalLink) {
          handleExternalClick();
        }
      }}
    >
      <span>
        {primaryBtnText}{" "}
        {noIcon ? (
          ""
        ) : (
          <svg
            width="7"
            height="10"
            viewBox="0 0 7 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 8.97443L6 4.97443L1 0.974426"
              stroke="white"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </span>
    </button>
  );
};
export default PrimaryButton;
